import React from 'react';
import { StudioMode } from './useMessageCompositionStudio';

const block = 'bg-gray-200 dark:bg-slate-700 rounded';
const soft = 'bg-gray-100 dark:bg-slate-800 rounded';

const ChannelPickerSkeleton: React.FC = () => (
    <div className="max-w-4xl mx-auto py-10 animate-pulse">
        <div className="flex flex-col items-center gap-3 mb-8">
            <div className={`${block} h-7 w-80`} />
            <div className={`${soft} h-4 w-96`} />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="rounded-2xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-5">
                    <div className={`${soft} h-11 w-11 rounded-xl mb-4`} />
                    <div className={`${block} h-5 w-28 mb-2`} />
                    <div className={`${soft} h-3 w-20 mb-3`} />
                    <div className={`${soft} h-4 w-full mb-1.5`} />
                    <div className={`${soft} h-4 w-5/6 mb-3`} />
                    <div className={`${soft} h-3 w-3/4`} />
                </div>
            ))}
        </div>
    </div>
);

const StudioLayoutSkeleton: React.FC = () => (
    <div className="animate-pulse">
        <div className="flex items-center justify-between gap-4 py-3">
            <div className="flex items-center gap-3">
                <div className={`${soft} h-9 w-9 rounded-lg`} />
                <div className="space-y-2">
                    <div className={`${block} h-4 w-48`} />
                    <div className={`${soft} h-3 w-32`} />
                </div>
            </div>
            <div className={`${soft} h-6 w-24 rounded-full`} />
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-[220px_minmax(0,1fr)] xl:grid-cols-[220px_minmax(0,1fr)_400px] gap-5 py-4">
            <aside className="space-y-2">
                {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className={`${soft} h-10 w-full rounded-lg`} />
                ))}
            </aside>
            <main className="space-y-4">
                <div className={`${block} h-4 w-40`} />
                <div className={`${soft} h-10 w-full`} />
                <div className={`${block} h-4 w-32`} />
                <div className={`${soft} h-64 w-full`} />
                <div className="flex gap-2">
                    <div className={`${soft} h-8 w-24 rounded-md`} />
                    <div className={`${soft} h-8 w-24 rounded-md`} />
                </div>
            </main>
            <aside className="hidden xl:block">
                <div className="rounded-xl border border-gray-200 dark:border-slate-700 p-4 space-y-3">
                    <div className={`${block} h-4 w-28`} />
                    <div className={`${soft} h-5 w-full`} />
                    <div className={`${soft} h-40 w-full`} />
                    <div className={`${soft} h-4 w-5/6`} />
                    <div className={`${soft} h-4 w-2/3`} />
                </div>
            </aside>
        </div>
    </div>
);

const StudioSkeleton: React.FC<{ mode: StudioMode }> = ({ mode }) =>
    mode === 'new' ? <ChannelPickerSkeleton /> : <StudioLayoutSkeleton />;

export default StudioSkeleton;
